export default __webpack_public_path__ + "static/media/projectfeature4.74e0d6ae.png";